import React from 'react';
import { useIntl } from 'react-intl';
import { cn } from 'cn';
import { Spinner as UISpinner } from '@/components/ui/spinner';

type SpinnerProps = Omit<React.ComponentPropsWithoutRef<'svg'>, 'color'> & {
  /** `primary` usa a cor primária. Sem `color`, usa a cor do texto em volta (dentro de botão, a do botão). */
  color?: 'primary';
  /** Classes do ícone. O tamanho é uma classe `tw:size-*` (ex.: `tw:size-8`); sem ela, 16px, o ícone do botão. */
  className?: string;
  /** Estilo do ícone. */
  style?: React.CSSProperties;
};

/**
 * Indicador de carregamento (ícone girando), 16px por padrão; outro tamanho vai por `className` (`tw:size-8`). Em botão, vai no `leftIcon`/`rightIcon` com `aria-hidden` (o botão leva `disabled` e `aria-busy`). O leitor de tela lê "Carregando"; dentro de botão ou com texto visível ao lado, passe `aria-hidden`.
 * @import import Spinner from 'src/componentes/spinner';
 */
function Spinner({ color, className, ...rest }: SpinnerProps) {
  const intl = useIntl();

  return (
    <UISpinner
      aria-label={intl.formatMessage({
        id: 'carregando',
        defaultMessage: 'Carregando',
      })}
      className={cn(color === 'primary' && 'tw:text-primary', className)}
      strokeWidth={1.75}
      {...rest}
    />
  );
}

export default Spinner;
